/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnChanges, SimpleChanges} from '@angular/core';
import template from './advertiser-analysis-page.component.html';
import {LocalUserPermissions} from '../../components/session/local-user-permissions';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

type AdvertiserAnalysisTab = 'charts' | 'reports' | 'traffic' | 'location';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-advertiser-analysis-page',
  template
})
export class AdvertiserAnalysisPageComponent implements OnChanges {
  @Input() model: any;
  private _isNewDirect: boolean | undefined;

  @Input()
  set isNew(value: boolean) {
    this._isNewDirect = value;
  }

  get isNew(): boolean {
    return this._isNewDirect;
  }

  effectiveIsNew = false;
  activeTab: AdvertiserAnalysisTab = 'charts';
  reportsLoaded = false;
  trafficLoaded = false;
  locationLoaded = false;
  canSeeReports = false;

  constructor(
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
    this.canSeeReports = LocalUserPermissions.getAnyVisibility().RUN_REPORTS === true
      || LocalUserPermissions.getAnyVisibility().AX_ADVERTISER;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isNew) {
      this.effectiveIsNew = !!this.isNew;
    }
  }

  selectTab(tab: AdvertiserAnalysisTab): void {
    this.activeTab = tab;
    if (tab === 'reports') {
      this.reportsLoaded = true;
    } else if (tab === 'traffic') {
      this.trafficLoaded = true;
    } else if (tab === 'location') {
      this.locationLoaded = true;
    }
  }

}
